"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var text_styles_modal_html_1 = __importDefault(require("./text-styles-modal.html"));
require("./text-styles-modal.less");
(function (module) {
    'use strict';
    module.factory('prTextStylesModal', [
        '$filter',
        '$rootScope',
        'qstrap.modal',
        function ($filter, $rootScope, modal) {
            function open() {
                var $scope = $rootScope.$new();
                modal({
                    show: true,
                    scope: $scope,
                    controller: 'prTextStylesModalController',
                    templateUrl: text_styles_modal_html_1.default
                });
            }
            return {
                open: open,
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
